module.exports = __webpack_public_path__ + "img/fiftythree-pencil.934ea796.webp";